import { dashboard as dashboardRoutes } from "../routes/index";

function normalizeValue(value) {
  return value == null ? "" : String(value);
}

function normalizePath(path) {
  const value = normalizeValue(path).trim();
  if (!value || value === "x") return "";
  return value.charAt(0) === "/" ? value : `/${value}`;
}

function humanizePath(path) {
  return (
    normalizeValue(path)
      .replace(/:\w+/g, "")
      .split("/")
      .filter(Boolean)
      .filter((part) => !["t", "index.php", "index", "php"].includes(part.toLowerCase()))
      .pop()
      ?.replace(/[_-]/g, " ")
      .replace(/\b\w/g, (letter) => letter.toUpperCase()) || "Route"
  );
}

function routeName(route, fallbackPath) {
  return normalizeValue(route.name).trim() || humanizePath(fallbackPath);
}

function wordsFromPath(path) {
  return normalizeValue(path)
    .replace(/:\w+/g, "")
    .split(/[^a-zA-Z0-9]+/)
    .filter((word) => word && !["t", "index", "php", "listing"].includes(word.toLowerCase()));
}

function flattenRoutes(routeList, parentName = "") {
  const flattened = [];

  routeList.forEach((route) => {
    if (!route) return;

    const path = normalizePath(route.path);
    const name = routeName(route, path);
    const category = parentName || name;

    if (path && route.component) {
      const keywords = [name, category, path, ...wordsFromPath(path)]
        .join(" ")
        .toLowerCase();

      flattened.push({
        label: parentName && parentName !== name ? `${parentName} - ${name}` : name,
        path,
        keywords,
      });
    }

    if (Array.isArray(route.children)) {
      flattened.push(...flattenRoutes(route.children, name));
    }
  });

  return flattened;
}

function buildRouteActions() {
  const seen = {};

  return flattenRoutes(dashboardRoutes).filter((route) => {
    const key = `${route.label}|${route.path}`;
    if (seen[key]) return false;
    seen[key] = true;
    return true;
  });
}

function scoreRoute(route, query) {
  const terms = normalizeValue(query)
    .toLowerCase()
    .split(/\s+/)
    .filter(Boolean);

  return terms.reduce((score, term) => {
    if (route.label.toLowerCase() === term) return score + 8;
    if (route.label.toLowerCase().indexOf(term) !== -1) return score + 4;
    if (route.keywords.indexOf(term) !== -1) return score + 2;
    return score;
  }, 0);
}

export const ROUTE_ACTIONS = buildRouteActions();

export function findRouteAction(query) {
  return ROUTE_ACTIONS
    .map((route) => ({ ...route, score: scoreRoute(route, query) }))
    .filter((route) => route.score > 0)
    .sort((a, b) => b.score - a.score || a.label.localeCompare(b.label))[0];
}
